import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function BookIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M1.66675 2.5h5c.88405 0 1.7319.35119 2.35702.97631.62512.62512.97633 1.47297.97633 2.35702V17.5c0-.663-.26341-1.2989-.73225-1.7678C8.79901 15.2634 8.16312 15 7.50008 15H1.66675V2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 2.5h-5c-.884 0-1.7319.35119-2.357.97631C10.3512 4.10143 10 4.94928 10 5.83333V17.5c0-.663.2634-1.2989.7322-1.7678C11.2011 15.2634 11.837 15 12.5 15h5.8333V2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
